const HTML_TAGS = new Set([
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'bdi',
  'bdo',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'menu',
  'meta',
  'meter',
  'nav',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'picture',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'section',
  'select',
  'slot',
  'small',
  'source',
  'span',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'template',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'u',
  'ul',
  'var',
  'video',
  'wbr'
]);

const MAX_HOST_FRAMES = 10;

const parseFrameName = (line: string): string => {
  const frame = line.trim().replace(/^at /, '');

  return /[(@]|:\/\//.test(frame) ? '' : frame;
};

export const getComponentStackFingerprint = (componentStack: string): string =>
  componentStack
    .split('\n')
    .map(parseFrameName)
    .filter(name => HTML_TAGS.has(name))
    .slice(0, MAX_HOST_FRAMES)
    .join('>');

const getReactErrorCode = (message: string): string => {
  const [, code] = /Minified React error #(\d+)/.exec(message) ?? [];

  return code ? `react-${code}` : 'react-recoverable';
};

export const getRecoverableErrorGroupingHash = (
  error: Error,
  componentStack: string
): string => {
  const code = getReactErrorCode(error.message);
  const fingerprint = getComponentStackFingerprint(componentStack);

  return fingerprint ? `${code}|${fingerprint}` : code;
};
